"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _react = _interopRequireWildcard(require("react"));
var _ThemeProviderContext = _interopRequireDefault(require("../ThemeProvider/_ThemeProviderContext"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _default = exports.default = function _default(styles) {
  return function (WrappedComponent) {
    var Component = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
      var themeProviderContext = (0, _react.useContext)(_ThemeProviderContext.default);
      var _ref = themeProviderContext || {},
        _ref$theme = _ref.theme,
        theme = _ref$theme === void 0 ? 'concur_default' : _ref$theme;
      var classNameMap = styles[theme];

      // we want to make sure we don't send back an empty classNameMap object
      // since a lot of components will unconditionally spread props to the DOM
      var extraProps = {};
      if ((0, _keys.default)(classNameMap || {}).length > 0) {
        extraProps.classNameMap = classNameMap;
      }
      return /*#__PURE__*/_react.default.createElement(WrappedComponent, (0, _extends2.default)({}, props, {
        ref: ref
      }, extraProps));
    });
    (0, _hoistNonReactStatics.default)(Component, WrappedComponent);
    Component.displayName = WrappedComponent.displayName || WrappedComponent.name;
    Component.defaultProps = WrappedComponent.defaultProps;
    Component.propTypes = WrappedComponent.propTypes;
    return Component;
  };
};